import React, { FC, useState } from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import parseYoutubeUrl from '@utils/parseYoutubeUrl'
import { Icon } from '@mch-group/uikit-components'

const mID = 'youtube-player'

const YouTubeIFrame: FC<IYouTubeIFrame> = ({ id, youtubeUrl, className, placeholder }) => {
  const [isVideoShowing, setIsVideoShowing] = useState(placeholder ? false : true)
  return (
    <>
      {!isVideoShowing ?
        <Wrapper onClick={() => {setIsVideoShowing(true)}}>
          <StyledVideoPlaceholder $placeholder={placeholder}>
            <Icon name='play' color='var(--bs-mch-white)' size={56} />
          </StyledVideoPlaceholder>
        </Wrapper>
        : <div className={classNames(className, mID)}>
          <iframe
            className={`${mID}__iframe`}
            allowFullScreen={true}
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            title='Meet the artists | Tolia Astakhishvili'
            width='640'
            height='360'
            src={`https://www.youtube-nocookie.com/embed/${parseYoutubeUrl(youtubeUrl)}?autoplay=1`}
            id={id}
          />
        </div>
      }
    </>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`

const StyledVideoPlaceholder = styled.div<any>`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${(props) => props.$placeholder});
`

const YouTubeIFRAME = styled(YouTubeIFrame)`
  .${mID} {
    &__iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }

  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
`

interface IYouTubeIFrame {
  id: string,
  youtubeUrl: string,
  className?: string,
  placeholder?: string
}

export default YouTubeIFRAME
